import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-badge';
@customElement(tagName)
export class TmBadge extends TmBaseComponent {
    @property({ type: Boolean })
    public uppercase = false;

    protected render() {
        return html`<div
            class=${classMap({
                'px-2 py-px': true,
                'bg-[--badge-background]': true,
                'border border-[--badge-border] rounded': true,
                'text-xs text-[--badge-text] text-center': true,
                'font-medium whitespace-nowrap': true,
                uppercase: this.uppercase,
            })}
        >
            <slot></slot>
        </div>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    --badge-background: var(--tm-color-gray-light-30);
                    --badge-border: var(--tm-color-gray-light);
                    --badge-text: var(--tm-color-gray-medium);
                    display: inline-block;
                }
                :host([theme='dark']) {
                    --badge-background: var(--tm-color-gray-light-15);
                    --badge-border: var(--tm-color-gray-light-15);
                    --badge-text: var(--jh-color-gray-100);
                }
                :host([success]) {
                    --badge-background: var(--content-positive);
                    --badge-border: var(--content-positive);
                    --badge-text: var(--jh-color-gray-0);
                }
                :host([success][theme='dark']) {
                    --badge-text: var(--jh-color-gray-900);
                }
                :host([error]) {
                    --badge-background: var(--content-negative);
                    --badge-border: var(--content-negative);
                    --badge-text: var(--jh-color-gray-0);
                }
                :host([error][theme='dark']) {
                    --badge-text: var(--jh-color-gray-900);
                }
                :host([primary]) {
                    --badge-background: var(--brand-primary);
                    --badge-border: var(--brand-primary);
                    --badge-text: var(--jh-color-gray-0);
                }
                :host([primary][theme='dark']) {
                    --badge-background: var(--brand-200);
                    --badge-border: var(--brand-200);
                    --badge-text: var(--jh-color-gray-900);
                }
                :host([warning]) {
                    --badge-background: var(--content-attention);
                    --badge-border: var(--content-attention);
                    --badge-text: var(--jh-color-gray-0);
                }
                :host([warning][theme='dark']) {
                    --badge-background: var(--content-attention);
                    --badge-border: var(--content-attention);
                    --badge-text: var(--jh-color-gray-900);
                }
                :host([edited]) {
                    --badge-background: var(--content-highlight);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmBadge;
    }
}
